import { Component, Inject, ViewChild } from '@angular/core';

import { ProductConfig } from 'app/product-designer-config';
import { ProductService } from 'core/product/product.service';
import { Utils } from 'core/utils';
import { SingleOptionChooserComponent
       } from '../single-option-chooser/single-option-chooser.component';

import { EventTrackingService } from 'core/tracking/event-tracking.service';

@Component({
  selector: 'product-chooser',
  templateUrl: './product-chooser.component.html',
  styleUrls: ['./product-chooser.component.scss'],
})
export class ProductChooserComponent
    extends SingleOptionChooserComponent
{
  private productService: ProductService;
  public productSize: string;

  public trackById: Object = Utils.trackById;

  @ViewChild('productChooser') public productChooser: any;
  constructor(
      @Inject(ProductService) productService: ProductService,
      @Inject(EventTrackingService) private eventTrackingService:
          EventTrackingService)
  {
    super();
    this.productService = productService;
    this.selectedValue = this.productService.getCurrentProduct();
    this.options = this.productService.getProducts();
  }

  public onClick(e: Event): void
  {
    this.productChooser.onContainerClick(e);
  }

  public setCurrentProduct(productConfig: ProductConfig): void
  {
    const oldProductId = this.productService.getCurrentProduct().id;

    if (oldProductId !== productConfig.id) {
      this.productService.setCurrentProduct(productConfig.id);

      this.eventTrackingService.track({
        category: productConfig.id,
        action: 'product_change',
        label: oldProductId,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/product-chooser/product-chooser.component.ts